import { useTranslation } from "react-i18next";
import {
  LeftSideContent,
  RightSideContent,
  SectionContent,
  SectionText,
  StyledTenYearsSection,
} from "./TenYearsSection.styled";
import SkewedTextBox from "../SkewedTextBox/SkewedTextBox";
import useDevice from "../../hooks/useDevice";
import SectionHeader from "../SectionHeader/SectionHeader";
import useTheme from "../../hooks/useTheme";

const TenYearsSection = () => {
  const { t } = useTranslation();
  const { isDesktop } = useDevice();
  const { theme } = useTheme();

  return (
    <StyledTenYearsSection>
      <SectionContent>
        <LeftSideContent>
          <SkewedTextBox
            prefixText={"Od "}
            mainText={" 2015."}
            width={isDesktop ? "430px" : "302px"}
            height={isDesktop ? "144px" : "86px"}
            skewAngle={-10}
          />
        </LeftSideContent>
        <RightSideContent>
          <SectionHeader
            title={t("pages.home.tenYearsSection.header")}
            showRectangle={false}
            color={theme.colors.white}
          />
          <SectionText $color={theme.colors.white}>
            {t("pages.home.tenYearsSection.text")}
          </SectionText>
        </RightSideContent>
      </SectionContent>
    </StyledTenYearsSection>
  );
};

export default TenYearsSection;
